import { makeStyles } from '@material-ui/core/styles';
import { useContext } from 'react';
import Fade from 'react-reveal/Fade';

import { ThemeContext } from '../../contexts/ThemeContext';

import expImgBlack from '../../assets/svg/experience/expImgBlack.svg';
import expImgWhite from '../../assets/svg/experience/expImgWhite.svg';

import './Experience.css';

function ExperienceCard({
  id,
  company,
  jobtitle,
  startYear,
  endYear,
  link,
  data,
  logo, // optional logo URL or imported asset
}) {
  const { theme } = useContext(ThemeContext);

  const useStyles = makeStyles((t) => ({
    experienceCard: {
      backgroundColor: theme.quaternary,
      '&:hover': {
        backgroundColor: theme.quaternaryLight, // Subtle shift on hover
      },
    },
  }));

  const classes = useStyles();

  return (
    <Fade bottom>
      <div
        className="experience-card-wrapper"
        style={{
          '--primary-color': theme.primary,
          '--background-color': theme.secondary
        }}
      >
        <div key={id} className={`experience-card ${classes.experienceCard}`}>
          <div
            className='expcard-img'
            style={{ backgroundColor: theme.primary50 }}
            aria-hidden='true'
          >
            <img
              className='company-logo'
              src={
                logo ? logo : theme.type === 'light' ? expImgBlack : expImgWhite
              }
              alt={company ? `${company} logo` : ''}
            />
          </div>

          <div className='experience-details'>
            <div className='experience-meta'>
              <h6 style={{ color: theme.primary }}>
                {startYear}-{endYear}
              </h6>
              <h4 className='jobtitle' style={{ color: theme.tertiary }}>
                {jobtitle}
              </h4>
              <h5 className='company' style={{ color: theme.tertiary }}>
                <a href={link} target='_blank' rel='noopener noreferrer' style={{ color: theme.primary }}>
                  {company}
                </a>
              </h5>
            </div>

            <ul className='points'>
              {data.map((da, idx) => (
                <li key={idx} style={{ color: theme.tertiary }}>
                  {da}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Fade>
  );
}

export default ExperienceCard;
